import { useEffect } from 'react';

const FilterHandler = ({
  params,
  gridData,
  campaignListDropdown,
  tagsList,
  columnDefs,
  filterDefaultSetRef,
}) => {
  useEffect(() => {
    if (!params || filterDefaultSetRef?.current || !gridData?.inputPayload?.filterJson) return;

    const filterJson = JSON.parse(gridData.inputPayload.filterJson);
    let existingFilters = { ...filterJson };

    // 📌 Handle Campaign Filter
    if (filterJson?.campaignId) {
      let campaignIds = filterJson.campaignId.conditions
        ? filterJson.campaignId.conditions.map((condition) => condition.filter).filter(Boolean)
        : [filterJson.campaignId.filter];

      const selectedCampaignNames = campaignListDropdown
        .filter((item) => campaignIds.includes(item.id))
        .map((item) => item.campaignName);

      if (selectedCampaignNames.length > 0) {
        existingFilters['campaignId'] = { filterType: 'set', values: selectedCampaignNames };
      } else {
        delete existingFilters['campaignId'];
      }
    }

    // 📌 Handle Tags Filter
    if (filterJson?.tagIds) {
      let tagIds = filterJson.tagIds.conditions
        ? filterJson.tagIds.conditions.map((condition) => condition.filter).filter(Boolean)
        : [filterJson.tagIds.filter];

      const selectedTagNames = tagsList
        .filter((item) => tagIds.includes(item.id))
        .map((item) => item.name[0]);

      if (selectedTagNames.length > 0) {
        existingFilters['tagIds'] = { filterType: 'set', values: selectedTagNames };
      } else {
        delete existingFilters['tagIds'];
      }
    }

    // ✅ Preserve all other existing filters
    params.api.setFilterModel(existingFilters);
    filterDefaultSetRef.current = true;
    params.api.onFilterChanged();
  }, []);

  return null; // This component doesn't render anything
};

export default FilterHandler;
